import { render, staticRenderFns } from "./Reservations.vue?vue&type=template&id=26b41048&"
import script from "./Reservations.vue?vue&type=script&lang=js&"
export * from "./Reservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports